/**
 * The site's talent trees come from talentsforever.com's export, whose CC BY 4.0 licence asks
 * for credit with a link wherever its data is shown.
 */
export function TalentsforeverCredit() {
  return (
    <p className="muted talentsforever-credit" data-testid="talentsforever-credit">
      Talent trees from <a href="https://talentsforever.com">talentsforever.com</a>
    </p>
  );
}
